import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import { Translate } from 'components/Translate';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import Fade from '@material-ui/core/Fade/Fade';
import { WithStyles } from 'shared/decorators/withStyles';

interface IProps {
  templateId: number;
}

@WithStyles(() => ({
  component: {
    '&.tooltip-card &.question-mark': {
      fontSize: '10px',

      color: '#78909C',
      backgroundColor: 'transparent',
      border: '1px solid #78909C',

      width: '14px',
      height: '14px',
      top: 0,
      margin: '0 4px'
    },
    '&.tooltip-card': {
      position: 'absolute',
      display: 'initial',
      top: '30%',
      '@media screen and (max-width: 960px)': {
        left: '-30%'
      }
    },
    '&.align-left': {
      left: '-25%'
    }
  }
}))
export default class TooltipInternational extends BaseComponent<null, IProps> {
  render() {
    const classAlignTooltip = this.props.templateId !== 18 ? 'align-left' : '';

    return (
      <span className={`${this.props.classes.component} tooltip-card ${classAlignTooltip}`}>
        <Tooltip
          arrow={true}
          id={`tooltip-information-currency`}
          placement="top"
          TransitionComponent={Fade}
          leaveTouchDelay={500}
          TransitionProps={{ timeout: 600 }}
          title={
            <div>
              <Translate term={`Valor com base na abertura da cotação do dólar. `} />
              <br />
              <Translate term={`Pode ocorrer variação do valor final devido`} />
              <br />
              <Translate term={`a cotação do dólar no fechamento da compra.`} />
            </div>
          }
        >
          <div className={`${this.props.classes.component} question-mark`}>i</div>
        </Tooltip>
      </span>
    );
  }
}
